"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadScript = void 0;
const loadScript = initFunction => {
  if (document.readyState !== 'loading') {
    initFunction();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', initFunction);
  } else {
    // dirty workaround
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState === 'complete') {
        initFunction();
      }
    });
  }
};
exports.loadScript = loadScript;
//# sourceMappingURL=loader.js.map